exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "select {\n  margin-bottom: 15px; }\n\n.btn-lg {\n  font-weight: 700;\n  font-size: 18px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/search-bar/search-bar.component.scss
// module id = 732
// module chunks = 1